/* Sofia Lark store: marks today's row and says whether the shop is open right now, in Riga time.
   Hours come from each row's data-hours ("12:00–19:00"; empty means closed). Without this file the
   section still lists every day's hours. */
(function () {
  'use strict';

  var TZ = 'Europe/Riga';
  var WEEKDAYS = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
  // "Atvērsim otrdien 12:00"
  var ON_DAY = ['pirmdien', 'otrdien', 'trešdien', 'ceturtdien', 'piektdien', 'sestdien', 'svētdien'];

  function rigaNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return {
      day: WEEKDAYS[parts.weekday],
      minutes: parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10)
    };
  }

  function parseHours(text) {
    var m = /(\d{1,2})[:.](\d{2})\s*[-–—]\s*(\d{1,2})[:.](\d{2})/.exec(text || '');
    if (!m) return null;
    return {
      open: parseInt(m[1], 10) * 60 + parseInt(m[2], 10),
      close: parseInt(m[3], 10) * 60 + parseInt(m[4], 10),
      openText: m[1].padStart(2, '0') + ':' + m[2],
      closeText: m[3].padStart(2, '0') + ':' + m[4]
    };
  }

  function update(store) {
    var rows = Array.prototype.slice.call(store.querySelectorAll('[data-sl-store-day]'));
    var status = store.querySelector('[data-sl-store-status]');
    var statusText = store.querySelector('[data-sl-store-status-text]');
    if (rows.length !== 7) return;

    var week = rows.map(function (row) { return parseHours(row.getAttribute('data-hours')); });
    if (!week.some(Boolean)) return;

    var now;
    try { now = rigaNow(); } catch (err) { return; }
    if (now.day === undefined || isNaN(now.minutes)) return;

    rows.forEach(function (row, i) {
      var isToday = i === now.day;
      row.classList.toggle('is-today', isToday);
      var dt = row.querySelector('dt');
      var label = row.querySelector('.sl-store__today');
      if (isToday && !label && dt) {
        label = document.createElement('span');
        label.className = 'sl-store__today';
        label.textContent = 'šodien';
        dt.appendChild(label);
      } else if (!isToday && label) {
        label.remove();
      }
    });

    var today = week[now.day];
    var open = today && now.minutes >= today.open && now.minutes < today.close;
    var text;

    if (open) {
      text = 'Šobrīd atvērts, līdz ' + today.closeText;
    } else if (today && now.minutes < today.open) {
      text = 'Šobrīd slēgts, atvērsim šodien ' + today.openText;
    } else {
      for (var k = 1; k <= 7; k++) {
        var d = (now.day + k) % 7;
        if (week[d]) {
          text = 'Šobrīd slēgts, atvērsim ' + (k === 1 ? 'rīt' : ON_DAY[d]) + ' ' + week[d].openText;
          break;
        }
      }
    }

    if (status && statusText && text) {
      statusText.textContent = text;
      status.classList.toggle('is-open', !!open);
      status.hidden = false;
    }
  }

  function init(store) {
    if (store.dataset.ready) return;
    store.dataset.ready = 'true';
    update(store);
    // Keep the line right for anyone who leaves the page open across opening or closing time.
    setInterval(function () { if (!document.hidden) update(store); }, 60000);
  }

  function boot() {
    document.querySelectorAll('[data-sl-store]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var store = event.target.querySelector('[data-sl-store]');
    if (store) init(store);
  });
})();
